import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useDeactivateLearningSpace } from '@/features/learning-spaces/hooks';

/**
 * `DELETE /learning-spaces/:id` is a soft deactivation with no
 * reactivation endpoint in the current backend - the confirmation copy
 * says so accurately rather than implying a reversible or hard delete.
 */
export function DeactivateLearningSpaceButton({
  learningSpaceId,
}: {
  readonly learningSpaceId: string;
}): JSX.Element {
  const deactivate = useDeactivateLearningSpace();
  const navigate = useNavigate();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button type="button" variant="destructive" size="sm" disabled={deactivate.isPending}>
          Nonaktifkan Ruang Belajar
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Nonaktifkan ruang belajar ini?</AlertDialogTitle>
          <AlertDialogDescription>
            Ruang belajar akan dinonaktifkan dan tidak lagi muncul dalam daftar aktif. Tindakan ini
            tidak dapat dibatalkan dari dalam aplikasi.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Batal</AlertDialogCancel>
          <AlertDialogAction
            disabled={deactivate.isPending}
            onClick={() => {
              deactivate.mutate(learningSpaceId, {
                onSuccess: () => {
                  void navigate('/learning-spaces');
                },
              });
            }}
          >
            Nonaktifkan
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
